import QueryClient from '@simppl/react-query/QueryClient';
import QueryClientProvider from '@simppl/react-query/QueryClientProvider';
import type { PropsWithChildren } from 'react';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
});

export default function AppProviders({ children }: PropsWithChildren) {
  return <QueryClientProvider queryClient={queryClient}>{children}</QueryClientProvider>;
}
